import { Card } from "antd";
import React from "react";

const Dashboard = () => {
  return (
    <>
      <Card title="News and updates" className="news-and-updates">
        <div id="card-candu" className="card-candu" />
      </Card>
      <Card title="Getting Started" className="getting-started">
        <div id="card-candu-getting-started" className="card-candu" />
      </Card>
    </>
  );
};

export default Dashboard;
